import ConfigCombo from "./../db/ConfigCombo.js";
import { generacionActual } from "./sesionDePeticiones.js";

// Cache de la promesa para no consultar el configcombo en cada navegación.
var _cache = null;
// #663 · De qué sesión es `_cache`. La promesa sale de la frontera, que calla lo que se le cuelgue
// desde otra sesión: guardada de una a otra, la sesión nueva no recibía nunca las naturalezas.
let _generacionDeLaCache = null;

function buildMaps(valores) {
  var items = [];
  var byCode = {};
  var bgColorByCode = {};
  var colorByCode = {};
  var badgeColorByCode = {};
  var labelByCode = {};
  (valores || []).forEach(function (v) {
    if (!v || !v.valor) return;
    var meta = v.metadatos || {};
    var entry = {
      valor: v.valor,
      label: v.label || v.valor,
      nombre: v.label || v.valor,
      bgColor: meta.bgColor || "",
      color: meta.color || "",
      badgeColor: meta.badgeColor || "gray"
    };
    items.push(entry);
    byCode[v.valor] = entry;
    bgColorByCode[v.valor] = entry.bgColor || "transparent";
    colorByCode[v.valor] = entry.color || "inherit";
    badgeColorByCode[v.valor] = entry.badgeColor;
    labelByCode[v.valor] = entry.label;
  });
  return { items: items, byCode: byCode, bgColorByCode: bgColorByCode, colorByCode: colorByCode, badgeColorByCode: badgeColorByCode, labelByCode: labelByCode };
}

const NaturalezasMaestro = {
  // Devuelve una promesa que resuelve a { items, byCode, bgColorByCode, colorByCode, badgeColorByCode, labelByCode }.
  // Cachea el resultado para que solo se haga UNA consulta por sesión.
  load: function () {
    if (_cache && _generacionDeLaCache === generacionActual()) return _cache;
    _generacionDeLaCache = generacionActual();
    _cache = ConfigCombo.getList({ filter: { codigo: "ITEM_NATURALEZAS" } })
      .then(function (res) {
        var combo = res && res.list && res.list[0];
        return buildMaps(combo && combo.valores);
      })
      .catch(function () {
        return buildMaps([]);
      });
    return _cache;
  },
  // Fuerza recarga (p.ej. tras editar el configcombo en runtime).
  reset: function () {
    _cache = null;
  }
};

export default NaturalezasMaestro;
